import en from './en.json'
import ro from './ro.json'

const languages = {
    ro: { translation: ro },
    en: { translation: en },
}

export default languages
